import { GetChatRoomMessagesParams } from 'types/services';
import { ChatMessage } from 'types/chats';
import { chatMessagesStoreMock } from 'services/mock/utils/chatMessagesModel';

export const getChatRoomMessages = async (
  params: GetChatRoomMessagesParams
): Promise<ChatMessage[]> => {
  return chatMessagesStoreMock.getMessagesByPage(params.page);
};
